/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupAssignmentUpdate
 */
export interface UserGroupAssignmentUpdate {
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUpdate
     */
    userGroupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignmentUpdate
     */
    userId?: string | null;
}

/**
 * Check if a given object implements the UserGroupAssignmentUpdate interface.
 */
export function instanceOfUserGroupAssignmentUpdate(value: object): value is UserGroupAssignmentUpdate {
    return true;
}

export function UserGroupAssignmentUpdateFromJSON(json: any): UserGroupAssignmentUpdate {
    return UserGroupAssignmentUpdateFromJSONTyped(json, false);
}

export function UserGroupAssignmentUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupAssignmentUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'userGroupId': json['userGroupId'] == null ? undefined : json['userGroupId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function UserGroupAssignmentUpdateToJSON(json: any): UserGroupAssignmentUpdate {
    return UserGroupAssignmentUpdateToJSONTyped(json, false);
}

export function UserGroupAssignmentUpdateToJSONTyped(value?: UserGroupAssignmentUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userGroupId': value['userGroupId'],
        'userId': value['userId'],
    };
}

